import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link, Navigate } from "react-router-dom";
import "../../styles/Dashboard.css";

export default function Dashboard() {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const { usuario } = useContext(AuthContext);

  useEffect(() => {
    const accepted = localStorage.getItem("termsAccepted");
    if (accepted === "true") {
      setTermsAccepted(true);
    } else {
    }
  }, []);

  const handleAcceptTerms = () => {
    localStorage.setItem("termsAccepted", "true");
    setTermsAccepted(true);
  };



  // Depuración del usuario
  // Verificación de acceso según el rol
  if (!usuario) {
    return <Navigate to="/login" replace />;
  }

  // Normalizar el rol
  const normalizedRol = usuario.rol ? usuario.rol.toLowerCase().trim() : null;
  // Verificar roles permitidos incluyendo conexadmin
  if (!["conexadmin", "administrador", "cliente", "trabajadores"].includes(normalizedRol)) {
    return <Navigate to="/no-autorizado" replace />;
  }

  return (
    <section className="section has-background-white">
      <div className="container" style={{ 
        maxWidth: "1000px", 
        margin: "0 auto",
        padding: "20px"
      }}>

        <div
          className="box"
          style={{
            backgroundColor: "#f8f9fa",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            padding: "24px",
            textAlign: "center",
            margin: "0 auto"
          }}
        >
          <h2 className="title is-4 has-text-warning">CONEX</h2>
          <p className="has-text-justified" style={{ lineHeight: "1.6" }}>
            Es una plataforma cuyo objetivo es “facilitar la gestión integral de los negocios de emprendedores pequeños a través de una plataforma ERP intuitiva, accesible y diseñada específicamente para optimizar procesos clave, impulsar la productividad y fomentar el crecimiento de una pequeña empresa.”
            Es desarrollada por la Fundación Nigma | Innovación y Futuro, una organización dedicada a democratizar el acceso a la tecnología y la innovación para fomentar el crecimiento de emprendedores.
            El uso de esta plataforma está sujeto a las siguientes cláusulas:
          </p>
          <ul className="mt-4" style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>Uso personal y no transferible: La licencia otorgada es únicamente para el usuario registrado y no puede ser compartida ni comercializada.</li>
            <li>Propiedad intelectual: Todos los derechos sobre el diseño, funcionalidad, código y contenido de la ERP son exclusivos de la Fundación Nigma Innovación y Futuro.</li>
            <li>Responsabilidad limitada: La fundación no se responsabiliza por pérdidas económicas derivadas del uso inadecuado de la herramienta o de problemas técnicos fuera de su control razonable.</li>
            <li>Actualizaciones y soporte: El acceso a actualizaciones y soporte técnico estará disponible conforme a los términos definidos en el contrato de usuario.</li>
          </ul>

          <div className="mt-5">
            <h3 className="title is-5 has-text-warning">Resumen de la Política de Protección de Datos Personales</h3>
            <ul className="content" style={{ listStyleType: "circle", paddingLeft: "20px" }}>
              <li><strong>1. Responsable:</strong> Fundación Nigma es quien gestiona tus datos personales.</li>
              <li><strong>2. Datos y uso:</strong> Solo se recopilan los necesarios para gestionar donaciones y comunicación.</li>
              <li><strong>3. Legalidad:</strong> El uso de tus datos se basa en tu consentimiento, acuerdos de donación o por requerimientos legales.</li>
              <li><strong>4. Seguridad:</strong> Se protegen tus datos y no se comparten con terceros, salvo excepciones legales.</li>
              <li><strong>5. Tus derechos:</strong> Puedes acceder, corregir, eliminar, oponerte o pedir la transferencia de tus datos.</li>
              <li><strong>6. Conservación:</strong> Tus datos solo se guardan mientras sean necesarios.</li>
              <li><strong>7. Terceros:</strong> Si se contrata a otros servicios, estos deben proteger tus datos igual que la fundación.</li>
              <li><strong>8. Contacto:</strong> Para dudas o reclamos: donaciones@fundacionnigma.org | info@fundacionnigma.org</li>
            </ul>
          </div>

          <div className="mt-5 is-flex is-justify-content-center">
            {!termsAccepted && (
              <button
                className="button is-warning"
                onClick={handleAcceptTerms}
              >
                Aceptar términos y condiciones
              </button>
            )}

            {termsAccepted && (
              <div className="mt-3 has-text-centered" style={{ width: '100%' }}>
                <Link
                  to="/dashboard/terminos-condiciones"
                  className="has-text-weight-semibold has-text-warning"
                  style={{ textDecoration: 'none' }}
                >
                  ✅ Has aceptado los términos y condiciones.
                </Link>
              </div>
            )}
          </div>
        </div>

      </div>
    </section>
  );
}
